import React, { Fragment } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import { Link } from 'formlabs-web-components/Link';
import { InteractiveDiv } from 'formlabs-web-components/Wrapper';

import './HeaderMenu.module.css';

const SiteSelector = ({
  open,
  sites,
  handleHoverSiteSelect,
  handleClickSiteSelect
}) => {
  const { t } = useTranslation();
  return (
    <InteractiveDiv
      styleName="main-menu-item site-selector"
      onMouseEnter={handleHoverSiteSelect}
      handler={handleClickSiteSelect}
    >
      <span styleName="top-level">
        {t('Dental')}
        <i
          className="fl-navigate_next"
          styleName={classnames({ show: open }, 'indicator')}
        />
      </span>
      <div styleName={classnames('invisible-padding', { show: open })}>
        <div styleName={classnames('mini-menu', { show: open })}>
          {sites.map(site => {
            const current =
              site.name.toLowerCase() === process.env.RAZZLE_CMS_SITE;
            return (
              <div styleName="site-link">
                {current ? (
                  <Fragment>
                    <p>
                      {site.name} <br />
                      <span styleName="url">{site.displayUrl}</span>
                    </p>
                    <p styleName="current">{t('Current')}</p>
                  </Fragment>
                ) : (
                  <Link to={site.url} target="_blank">
                    <p>
                      {site.name} <br />
                      <span styleName="url">{site.displayUrl}</span>
                    </p>
                    <p>
                      <i className="fl-external-link" />
                    </p>
                  </Link>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </InteractiveDiv>
  );
};
export default SiteSelector;
